module.exports = __webpack_public_path__ + "img/notification-disabled.853d0a86.svg";